import { z } from 'zod';
import { isoDateTimeSchema } from './common.js';
export const backupStorageModeSchema = z.enum(['local', 'local+offsite']);
const archiveSha256Schema = z.string().regex(/^[a-f0-9]{64}$/u);
const commitSchema = z.string().regex(/^[a-f0-9]{40}$/u);
const backupIdSchema = z.string().regex(/^[A-Za-z0-9._-]{1,180}$/u);
export const deploymentBackupEvidenceSchema = z
    .object({
    schemaVersion: z.literal(2),
    environment: z.enum(['test', 'staging', 'prod', 'production']),
    commit: commitSchema,
    backupId: backupIdSchema,
    archiveSha256: archiveSha256Schema,
    storageMode: backupStorageModeSchema,
    localBackupVerified: z.boolean(),
    offsiteBackupEnabled: z.boolean(),
    offsiteBackupVerified: z.boolean(),
    offsiteSnapshotId: z.string().min(8).optional(),
    verifiedAt: isoDateTimeSchema,
})
    .strict()
    .superRefine((value, context) => {
    const offsiteMode = value.storageMode === 'local+offsite';
    if (value.localBackupVerified !== true ||
        value.offsiteBackupEnabled !== offsiteMode ||
        value.offsiteBackupVerified !== offsiteMode ||
        (offsiteMode ? value.offsiteSnapshotId === undefined : value.offsiteSnapshotId !== undefined)) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Backup-Modus und Verifikationsnachweis sind widersprüchlich.',
        });
    }
});
export const restoreDrillEvidenceSchema = z
    .object({
    schemaVersion: z.literal(2),
    status: z.literal('SUCCESS'),
    environment: z.literal('staging'),
    storageMode: backupStorageModeSchema,
    restoreSource: z.enum(['local', 'offsite']),
    verifiedLocal: z.literal(true),
    verifiedOffsite: z.boolean(),
    source: z.enum(['local', 'github-actions']).optional(),
    workflow: z.literal('backup-restore-check.yml').optional(),
    backupId: backupIdSchema,
    archiveSha256: archiveSha256Schema,
    commit: z.string().regex(/^[a-f0-9]{40}$/u),
    snapshotId: z.string().min(8).optional(),
    completedAt: isoDateTimeSchema,
})
    .strict()
    .superRefine((value, context) => {
    const validSource = value.source === 'local'
        ? value.workflow === undefined
        : value.workflow === 'backup-restore-check.yml';
    if (!validSource) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Restore-Nachweis benötigt eine eindeutige lokale oder Workflow-Quelle.',
        });
    }
    const offsiteMode = value.storageMode === 'local+offsite';
    if (value.verifiedOffsite !== offsiteMode ||
        value.restoreSource !== (offsiteMode ? 'offsite' : 'local') ||
        (offsiteMode ? value.snapshotId === undefined : value.snapshotId !== undefined)) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Restore-Modus und Offsite-Nachweis sind widersprüchlich.',
        });
    }
});
const deploymentBackupStatusBaseSchema = z.object({
    lastLocalBackupAt: isoDateTimeSchema.nullable(),
    localBackupVerified: z.boolean(),
    lastRestoreTestAt: isoDateTimeSchema.nullable(),
    restoreSource: z.enum(['local', 'offsite']).nullable(),
});
export const deploymentBackupStatusSchema = z.discriminatedUnion('resticEnabled', [
    deploymentBackupStatusBaseSchema
        .extend({
        resticEnabled: z.literal(false),
        storageMode: z.literal('local'),
    })
        .strict(),
    deploymentBackupStatusBaseSchema
        .extend({
        resticEnabled: z.literal(true),
        storageMode: z.literal('local+offsite'),
        offsiteBackupVerified: z.boolean(),
    })
        .strict(),
]);
//# sourceMappingURL=backup-evidence.js.map